'use client';

import { CheckboxIcon } from '@/components/icons/checkbox-icon';
import { cn } from '@/lib/utils';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import * as React from 'react';

const Checkbox = ({
  className,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root>): React.JSX.Element => {
  return (
    <CheckboxPrimitive.Root className={cn(
      'peer border-black dark:bg-input/30 data-[state=checked]:bg-primary data-[state=checked]:text-(--on-primary)',
      'dark:data-[state=checked]:bg-primary data-[state=checked]:border-primary focus-visible:border-ring',
      'focus-visible:ring-ring/50 aria-invalid:ring-primary dark:aria-invalid:ring-primary/40',
      'aria-invalid:border-destructive size-4 shrink-0 rounded-[4px] border shadow-xs transition-shadow outline-none',
      'aria-invalid:ring-2 disabled:cursor-not-allowed disabled:opacity-50',
      className
    )}
    data-slot="checkbox"
    {...props}
    >
      <CheckboxPrimitive.Indicator className="flex items-center justify-center text-current transition-none"
        data-slot="checkbox-indicator"
      >
        <CheckboxIcon className="size-3.5" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
};

export { Checkbox };
